import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";

import CounterpartyCheck from "../components/CounterpartyCheckContent";

function counterpartyCheck({ width, onResize }: Column.Options) {
	return base(
		ColumnId.CounterpartyCheck,
		(item) => <CounterpartyCheck item={item} />,
		{
			width,
			sortable: false,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default counterpartyCheck;
